import React, { useContext, useState, useEffect, useMemo, useRef, useCallback } from "react";
import { Theme } from "@rjsf/bootstrap-4";
import { withTheme, utils } from "@rjsf/core";

import { Progress } from "reactstrap";



import { Upload } from "@aws-sdk/lib-storage";
import { S3Client } from "@aws-sdk/client-s3";

import { FileMosaic } from "@files-ui/react";

import JSZip from "jszip";
import useFetch from "../../components/useFetch";
import { CustomWidget } from "../../components/widgets/CustomWidgets";
import ErrorScreen from "../../components/error/ErrorScreen";
import Loader from "../../components/Loader";
import ModelUploadSummary from "../../components/modal/NavPanes/ModelUploadSummary";
import AlertComponent from "../../components/alert/AlertComponent";
import { ArrowRightIcon, BackIcon, CloseIcon, ModelIcon, RadarIcon } from "../Common/SvgIcons/WorkflowIcons";
import "../project/data/AddDataset.scss";
import "../project/CreateProjectForm.scss";
import {
  buildDatasetFlowWidgets,
  DatasetFlowArrayFieldTemplate,
  DatasetFlowFieldTemplate,
  DatasetFlowObjectFieldTemplate,
} from "../project/data/DatasetFormUI";
import { getCokkie } from "../login/Login";
import { alertContext } from "../../components/modal/ModalComponent";
import "./ModelHub.css";
// import Configuration2 from "../../components/modal/NavPanes/Configuration2";
// import VideoStreaming from "../project/data/add_data/VideoStreaming";

var activeStep = 0;
const S3_BUCKET = `${window.ENV.AWS_DEVICE_BUCKET}`;
const REGION = `${window.ENV.AWS_REGION}`;

const extractResponseMessage = (value, fallback = "Final submission failed") => {
  if (!value) return fallback;
  if (typeof value === "string") return value;
  if (Array.isArray(value)) {
    return value.map((item) => extractResponseMessage(item, "")).filter(Boolean).join(", ") || fallback;
  }
  if (typeof value === "object") {
    return (
      extractResponseMessage(value.message, "") ||
      extractResponseMessage(value.detail, "") ||
      extractResponseMessage(value.error, "") ||
      fallback
    );
  }
  return String(value);
};

const isErrorSubmissionResult = (response, result) => {
  const status = result?.status || result?.detail?.status;
  const statusCode = result?.status_code || result?.detail?.status_code;

  return (
    !response.ok ||
    String(status || "").toLowerCase() === "error" ||
    Number(statusCode) >= 400
  );
};

// Initialize Form with theme
const registry = utils.getDefaultRegistry();
const defaultFileWidget = registry.widgets["FileWidget"];
const defaultRangeWidget = registry.widgets["RangeWidget"];

Theme.widgets = {
  ...Theme.widgets,
  FileWidget: defaultFileWidget,
  RangeWidget: defaultRangeWidget
};

const Form = withTheme(Theme);

const prepareModelFormSchema = (schemaNode) => {
  if (Array.isArray(schemaNode)) {
    return schemaNode.map(prepareModelFormSchema);
  }
  if (!schemaNode || typeof schemaNode !== "object") return schemaNode;

  return Object.entries(schemaNode).reduce((preparedNode, [key, value]) => {
    if (key === "format" && value === "data-url") return preparedNode;
    preparedNode[key] = prepareModelFormSchema(value);
    return preparedNode;
  }, {});
};

const findFieldSchema = (schemaNode, fieldName) => {
  if (!schemaNode || typeof schemaNode !== "object") return undefined;

  if (schemaNode.properties?.[fieldName]) {
    return schemaNode.properties[fieldName];
  }

  for (const childNode of Object.values(schemaNode)) {
    if (!childNode || typeof childNode !== "object") continue;
    const match = findFieldSchema(childNode, fieldName);
    if (match) return match;
  }

  return undefined;
};

const applyOwnershipAccessDefaults = (jsonSchema, currentFormData = {}) => {
  const nextFormData = { ...currentFormData };
  let changed = false;

  ["Ownership", "Model Access"].forEach((fieldName) => {
    const currentValue = nextFormData[fieldName];
    const hasValue =
      currentValue !== undefined && currentValue !== null && currentValue !== "";
    if (hasValue) return;

    const fieldSchema = findFieldSchema(jsonSchema, fieldName);
    const defaultValue =
      fieldSchema?.default ??
      jsonSchema?.default?.[fieldName] ??
      fieldSchema?.enum?.[0] ??
      fieldSchema?.oneOf?.[0]?.const ??
      fieldSchema?.anyOf?.[0]?.const;
    if (defaultValue === undefined) return;

    nextFormData[fieldName] = defaultValue;
    changed = true;
  });

  return changed ? nextFormData : currentFormData;
};

const FileWidget = ({ onChange, uploading, uploadProgress, onUpload, selectedFile }) => {
  const [files, setFiles] = useState(() =>
    selectedFile
      ? [{ id: `${selectedFile.name}-selected`, file: selectedFile, preview: null }]
      : []
  );
  const [error, setError] = useState(null);
  const fileInputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);

  useEffect(() => {
    if (!selectedFile) {
      setFiles((current) => (current.length ? [] : current));
      return;
    }

    setFiles((current) => {
      if (
        current.some(
          (item) => item.file === selectedFile || item.file?.name === selectedFile.name
        )
      ) {
        return current;
      }

      return [
        {
          id: `${selectedFile.name}-selected`,
          file: selectedFile,
          preview: selectedFile.type?.startsWith("image/")
            ? URL.createObjectURL(selectedFile)
            : null,
        },
      ];
    });
  }, [selectedFile]);

  const handleFiles = async (newFiles) => {
    setError(null);
    if (newFiles.length === 0) return;

    const isZipFile = newFiles.every((fileWrapper) =>
      fileWrapper.file.name.toLowerCase().endsWith('.zip')
    );

    const allowedExtensions =
      activeStep === 0
        ? ['.zip', '.onnx', '.bin']
        : ['.zip', '.jpg', '.jpeg', '.png'];

    const areImageFiles = newFiles.every((fileWrapper) =>
      allowedExtensions.some((ext) =>
        fileWrapper.file.name.toLowerCase().endsWith(ext)
      )
    );

    if (activeStep === 0) {
      if (newFiles.length > 1) {
        setError("You can only select one file.");
        return;
      }

      const fileWrapper = newFiles[0];
      const isAllowedModelFile = allowedExtensions.some((ext) =>
        fileWrapper.file.name.toLowerCase().endsWith(ext)
      );
      if (!isAllowedModelFile) {
        setError("You must select a .zip, .onnx, or .bin file.");
        return;
      }

      setFiles([fileWrapper]);
      if (isZipFile) {
        handleZipUpload(fileWrapper.file);
      } else {
        handleImageUpload([fileWrapper]);
      }
      return;
    }

    // if (activeStep === 0) {
    //   // ✅ Enforce single file
    //   if (newFiles.length > 1) {
    //     setError("You can only select one file.");
    //     return;
    //   }
  
    //   const fileWrapper = newFiles[0];
    //   const file = fileWrapper.file;
    //   const fileName = file.name.toLowerCase();
  
    //   if (fileName.endsWith(".zip")) {
    //     // ✅ Already zip — upload directly
    //     setFiles([fileWrapper]);
    //     handleZipUpload(file);
    //   } else if (/\.(onnx|bin)$/i.test(fileName)) {
    //     // ✅ Not a zip — compress it into a zip
    //     try {
    //       const zip = new JSZip();
    //       zip.file(file.name, file);
    //       const zipBlob = await zip.generateAsync({ type: "blob" });
  
    //       const timestamp = getISTTimestamp();
    //       const finalZipName = `${file.name.replace(/\.[^/.]+$/, "")}_${timestamp}.zip`;
    //       const zippedFile = new File([zipBlob], finalZipName, {
    //         type: "application/zip",
    //       });
  
    //       console.log("📦 Created zip from non-zip file:", zippedFile);
  
    //       setFiles([{ file: zippedFile }]);
    //       handleZipUpload(zippedFile);
    //     } catch (err) {
    //       console.error("❌ Failed to create zip:", err);
    //       setError("Failed to compress the file into zip.");
    //     }
    //   } else {
    //     setError("Invalid file type. Only .zip, .onnx, or .bin allowed.");
    //   }
  
    //   return;
    // }

    if (isZipFile && newFiles.length === 1) {

      setFiles(newFiles);
      handleZipUpload(newFiles[0].file);
    } else if (areImageFiles && newFiles.length > 0) {

      setFiles(newFiles);
      handleImageUpload(newFiles);
    } else {

      setError("You must select files that are of an allowed type.");
    }
  };




  const handleZipUpload = (zipFile) => {
    console.log("Uploading zip file:", zipFile);
    onChange(zipFile.name);
    onUpload(zipFile);
  };

  const getISTTimestamp = () => {
    const now = new Date();

    const istTime = new Date(now.getTime());



    const datePart = istTime.toISOString().split("T")[0]; // yyyy-mm-dd
    const timePart = istTime
      .toTimeString()
      .split(" ")[0]
      .replace(/:/g, "_"); // HH_mm_ss
    return `${datePart}_${timePart}`;
  }



  const handleImageUpload = async (selectedFiles) => {
    setError(null);
    const zip = new JSZip();
    const imageFiles = [];
    const fileNameTracker = new Set(); // Track duplicates

    try {
      // 1️⃣ Separate image files and zip files
      for (const fileWrapper of selectedFiles) {
        const { file } = fileWrapper;
        const fileName = file.name.toLowerCase();

        if (fileName.endsWith(".zip")) {
          console.log("Extracting images from zip:", fileName);
          const zipContent = await JSZip.loadAsync(file);
          await extractImagesRecursively(zipContent, imageFiles);
        } else if (/\.(jpg|jpeg|png|bin|onnx)$/i.test(fileName)) {
          imageFiles.push(file);
        }
      }

      if (imageFiles.length === 0) {
        setError("No valid images found in the selected files.");
        return;
      }

      console.log(`✅ Total extracted + uploaded images before renaming: ${imageFiles.length}`);

      // 2️⃣ Add files to zip while ensuring unique names
      for (const imgFile of imageFiles) {
        let baseName = imgFile.name;
        let nameWithoutExt = baseName.replace(/\.[^/.]+$/, "");
        let ext = baseName.split(".").pop();
        let uniqueName = baseName;
        let counter = 1;

        // Rename if duplicate
        while (fileNameTracker.has(uniqueName)) {
          uniqueName = `${nameWithoutExt}(${counter}).${ext}`;
          counter++;
        }

        fileNameTracker.add(uniqueName);
        zip.file(uniqueName, imgFile);
      }

      // 3️⃣ Create final combined zip
      const zipContent = await zip.generateAsync({ type: "blob" });
      const timestamp = getISTTimestamp();
      const finalZipFileName = `combined_images_${timestamp}.zip`;
      const finalZipFile = new File([zipContent], finalZipFileName, {
        type: "application/zip",
      });

      console.log("📦 Final combined zip created with unique filenames:", finalZipFile);

      // 4️⃣ Trigger upload
      onChange(finalZipFile.name);
      onUpload(finalZipFile);
    } catch (err) {
      console.error("❌ Error processing images:", err);
      setError("Failed to process selected files. Please try again.");
    }
  };

  const extractImagesRecursively = async (zipFolder, imageFiles) => {
    const entries = Object.keys(zipFolder.files);

    for (const entryName of entries) {
      const entry = zipFolder.files[entryName];

      if (entry.dir) continue;

      if (/\.(jpg|jpeg|png)$/i.test(entry.name)) {
        const blob = await entry.async("blob");
        const cleanName = entry.name.replace(/^.*[\\\/]/, ""); // filename only
        const extractedFile = new File([blob], cleanName, {
          type: "image/" + cleanName.split(".").pop(),
        });

        imageFiles.push(extractedFile);
      }
    }
  };


  const removeFile = (id) => {
    console.log('FileUploadWidget - Removing file with id:', id);
    const newFiles = files.filter(f => f.id !== id);
    setFiles(newFiles);
    if (newFiles.length === 0) {
      onUpload(null);
      onChange(undefined);
      return;
    }
    const singleIsZip =
      newFiles.length === 1 &&
      newFiles[0].file &&
      newFiles[0].file.name.toLowerCase().endsWith(".zip");

    if (singleIsZip) {
      handleZipUpload(newFiles[0].file);
    } else {
      handleImageUpload(newFiles);
    }
  };


  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => {
    setDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const droppedFiles = Array.from(e.dataTransfer.files).map((file, idx) => ({
      id: `${file.name}-${idx}`,
      file,
      preview: file.type.startsWith("image/") ? URL.createObjectURL(file) : null,
    }));
    handleFiles(droppedFiles);
  };

  const handleFileSelect = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files || []).map((file, idx) => ({
      id: `${file.name}-${idx}`,
      file,
      preview: file.type.startsWith("image/") ? URL.createObjectURL(file) : null,
    }));
    e.target.value = "";
    handleFiles(selectedFiles);
  };

  const supportedTypes =
    activeStep === 0 ? ".zip, .onnx, .bin" : ".zip, .jpg, .jpeg, .png";
  const visibleFiles =
    files.length > 0
      ? files
      : selectedFile
        ? [{ id: `${selectedFile.name}-selected`, file: selectedFile, preview: null }]
        : [];

  return (
    <div className="file-upload-container">
      {error && <div className="text-danger small fw-semibold mb-2">{error}</div>}
      <div
        className={`em-dropzone text-center d-a flex-column ${visibleFiles.length === 0 ? "h-100 p-4" : "p-3"}`}
        style={{
          background: "transparent",
          border: dragOver
            ? "2px dashed var(--leading-color)"
            : "2px dashed var(--glass-color)",
          cursor: "pointer",
          minHeight: "180px",
        }}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={handleFileSelect}
      >
        {visibleFiles.length === 0 ? (
          <>
            <p className="em-drop-title mb-0">Drag your files here</p>
            <p className="em-drop-subtext">or browse your computer</p>
            <p className="em-drop-subtext mb-0">Allowed types: {supportedTypes}</p>
          </>
        ) : (
          <div className="w-100" onClick={(event) => event.stopPropagation()}>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <small className="text-secondary">Selected files</small>
            </div>
            <div className="d-flex flex-column gap-2">
              {visibleFiles.map((file) => (
                <FileMosaic
                  key={file.id}
                  {...file}
                  onDelete={() => removeFile(file.id)}
                  preview={false}
                  info
                />
              ))}
            </div>
          </div>
        )}
      </div>

      <input
        ref={fileInputRef}
        type="file"
        multiple={activeStep !== 0}
        accept={activeStep === 0 ? ".zip,.onnx,.bin" : ".zip,.jpg,.jpeg,.png"}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      {uploading && (
        <>
          <div className="text-center">{uploadProgress}%</div>
          <Progress value={uploadProgress} />
        </>
      )}
    </div>
  );
};



const ModelFileWidgetContext = React.createContext({
  uploading: false,
  uploadProgress: 0,
  onUpload: () => {},
  selectedFile: null,
});

const ModelFileWidget = (props) => {
  const extras = useContext(ModelFileWidgetContext);
  return (
    <FileWidget
      {...props}
      uploading={extras.uploading}
      uploadProgress={extras.uploadProgress}
      onUpload={extras.onUpload}
      selectedFile={extras.selectedFile}
    />
  );
};

const SourceCardWidget = ({ value, onChange }) => {
  const options = [
    {
      value: "BrowserUpload",
      label: "Upload from device",
      description: "Upload model files directly from your local machine.",
    },
    {
      value: "ProvideDownlodableLink",
      label: "Use downloadable link",
      description: "Provide a direct model artifact URL for ingestion.",
    },
  ];

  return (
    <div>
      <label className="dataset-flow-shell__field-label">Source</label>
      <div className="row g-2">
        {options.map((opt) => {
          const selected = value === opt.value;
          return (
            <div className="col-12 col-md-6" key={opt.value}>
              <div
                className={`em-choice-card ${selected ? "active" : ""}`}
                onClick={() => onChange(opt.value)}
                role="button"
              >
                <div className="em-choice-card__title">{opt.label}</div>
                <div className="em-choice-card__check">
                  <input type="radio" checked={selected} readOnly />
                </div>
                <div className="em-choice-card__desc">{opt.description}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const SelectablePillsWidget = ({
  schema,
  options,
  value,
  disabled,
  readonly,
  label,
  onChange,
  multiple,
}) => {
  const enumOptions = options?.enumOptions || [];
  const enumDisabled = options?.enumDisabled || [];
  const isMulti = Boolean(multiple) || schema?.type === "array";
  const selectedValues = Array.isArray(value) ? value : [];

  const isSelected = (optionValue) =>
    isMulti
      ? selectedValues.some((item) => item === optionValue)
      : optionValue === value;

  const handleSelect = (optionValue) => {
    if (isMulti) {
      const next = isSelected(optionValue)
        ? selectedValues.filter((item) => item !== optionValue)
        : [...selectedValues, optionValue];
      onChange(next);
      return;
    }

    onChange(
      schema?.type === "boolean"
        ? optionValue !== false && optionValue !== "false"
        : optionValue
    );
  };

  return (
    <div
      className="cpf-pill-row"
      role={isMulti ? "group" : "radiogroup"}
      aria-label={label || schema?.title}
    >
      {enumOptions.map((option) => {
        const itemDisabled =
          Array.isArray(enumDisabled) && enumDisabled.includes(option.value);
        const selected = isSelected(option.value);
        const isDisabled = disabled || itemDisabled || readonly;

        return (
          <div
            key={String(option.value)}
            className={
              "cpf-pill" +
              (selected ? " cpf-pill--active" : "") +
              (isDisabled ? " disabled opacity-50" : "")
            }
            onClick={() => {
              if (isDisabled) return;
              handleSelect(option.value);
            }}
            role={isMulti ? "checkbox" : "radio"}
            aria-checked={selected}
            aria-disabled={isDisabled || undefined}
          >
            {option.label}
          </div>
        );
      })}
    </div>
  );
};

const RadioPillsWidget = (props) => (
  <SelectablePillsWidget {...props} multiple={false} />
);

const CheckboxPillsWidget = (props) => (
  <SelectablePillsWidget {...props} multiple />
);

const ToggleButtonWidget = ({
  id,
  schema,
  options,
  value,
  required,
  disabled,
  readonly,
  label,
  onChange,
  onBlur,
  onFocus,
}) => {
  const enumOptions = options?.enumOptions || [];
  const enumDisabled = options?.enumDisabled || [];
  const hasValue = value !== undefined && value !== null && value !== "";
  const firstEnabledOption = enumOptions.find(
    (option) => !enumDisabled.includes(option.value)
  );
  const selectedValue = hasValue ? value : firstEnabledOption?.value;

  useEffect(() => {
    if (hasValue || firstEnabledOption?.value === undefined) return;

    onChange(
      schema?.type === "boolean"
        ? firstEnabledOption.value !== false && firstEnabledOption.value !== "false"
        : firstEnabledOption.value
    );
  }, [firstEnabledOption?.value, hasValue, onChange, schema?.type]);

  return (
    <div
      className="model-option-toggle"
      role="radiogroup"
      aria-label={label || schema?.title}
    >
      {enumOptions.map((option, index) => {
        const itemDisabled =
          Array.isArray(enumDisabled) && enumDisabled.includes(option.value);
        const optionId = `${id}_${index}`;
        const checked = option.value === selectedValue;

        return (
          <label
            key={option.value}
            className={`model-option-toggle__button ${checked ? "is-selected" : ""}`}
            htmlFor={optionId}
          >
            <input
              id={optionId}
              name={id}
              type="radio"
              disabled={disabled || itemDisabled || readonly}
              checked={checked}
              required={required}
              value={option.value}
              onChange={(event) =>
                onChange(
                  schema?.type === "boolean"
                    ? event.target.value !== "false"
                    : event.target.value
                )
              }
              onBlur={(event) => onBlur?.(id, event.target.value)}
              onFocus={(event) => onFocus?.(id, event.target.value)}
            />
            <span>{option.label}</span>
          </label>
        );
      })}
    </div>
  );
};

const ModelFlowFieldTemplate = (props) => {
  const isEnumOptionArray =
    props.schema?.type === "array" &&
    Boolean(
      props.schema?.uniqueItems ||
        props.schema?.items?.enum ||
        props.uiSchema?.["ui:widget"] === "checkboxes"
    );

  if (!isEnumOptionArray) {
    return <DatasetFlowFieldTemplate {...props} />;
  }

  return (
    <DatasetFlowFieldTemplate
      {...props}
      uiSchema={{
        ...(props.uiSchema || {}),
        "ui:widget": "SelectWidget",
      }}
    />
  );
};

export default function AddExternalModel(props) {
  const setAlert = useContext(alertContext);
  const [schema, setSchema] = useState();
  const [uischema, setUischema] = useState();
  const [formData, setFormData] = useState({});
  const [summary_for_ui, setSummaryforui] = useState();

  const [tempCredentials, setTempCredentials] = useState();
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [currentFile, setCurrentFile] = useState(null);
  const currentFileRef = useRef(null);
  const [streamingUrl, setStreamingUrl] = useState();
  const [formresult, setFormresult] = useState();
  const videoRecorderRef = useRef(null);
  const [model_path, setModelpath] = useState();
  const [loadingAction, setLoadingAction] = useState(null);
  const [ready, setReady] = useState(false);

  const buildModelUiSchema = (baseUiSchema = {}) => ({
    ...baseUiSchema,
    "Model Name": {
      ...(baseUiSchema["Model Name"] || {}),
      "ui:placeholder": "Enter model name",
    },
    Source: {
      ...(baseUiSchema.Source || {}),
      "ui:widget": "SourceCardWidget",
      "ui:options": { label: false },
    },
    ModelLink: {
      ...(baseUiSchema.ModelLink || {}),
      "ui:title": "Model Link",
      "ui:placeholder": "https://...",
    },
    Organization: {
      ...(baseUiSchema.Organization || {}),
      "ui:placeholder": "Enter organization name",
    },
    "Upload Model": {
      ...(baseUiSchema["Upload Model"] || {}),
      "ui:widget": "FileWidget",
    },
    ...(props.useOwnershipAccessToggles
      ? {
          Ownership: {
            ...(baseUiSchema.Ownership || {}),
            "ui:widget": "ToggleButtonWidget",
          },
          "Model Access": {
            ...(baseUiSchema["Model Access"] || {}),
            "ui:widget": "ToggleButtonWidget",
          },
        }
      : {}),
  });

  console.log(props);

  useEffect(() => {
    if (streamingUrl) {
      setReady(true);
      console.log("true");
    }
  }, [streamingUrl]);

  const widgets = useMemo(() => {
    const modelWidgets = {
      ...CustomWidget,
      SourceCardWidget,
      FileWidget: ModelFileWidget,
      ToggleButtonWidget,
      RangeWidget: defaultRangeWidget,
    };

    const datasetWidgets = !ready
      ? buildDatasetFlowWidgets({
          ...modelWidgets,
          VideoWidget: () => <Loader />,
        })
      : buildDatasetFlowWidgets(modelWidgets);

    return {
      ...datasetWidgets,
      RadioWidget: RadioPillsWidget,
      CheckboxesWidget: CheckboxPillsWidget,
    };
  }, [ready]);

  const url = `${props.path}`;
  const { data, loading, error, setLoad, alert } = useFetch(url, "get");
  const steps = data?.steppers || [];
  const isLastStep = schema && activeStep === data?.steppers?.length - 1;
  const getDisplayStepLabel = (stepLabel = "") =>
    stepLabel === "Summary" ? "Review" : stepLabel;
  const totalSteps = steps.length || 1;
  const currentRawStepLabel =
    steps?.[activeStep] || schema?.title || (isLastStep ? "Summary" : "Configuration");
  const currentStepLabel = getDisplayStepLabel(currentRawStepLabel);
  const currentStepNumber = Math.min(activeStep + 1, totalSteps);
  const visibleHeaderSteps =
    steps.length > 0
      ? steps.slice(0, currentStepNumber).map(getDisplayStepLabel)
      : [currentStepLabel];
  const getStepDescription = (stepLabel = "") => {
    const normalized = String(stepLabel || "").toLowerCase();

    if (isLastStep || normalized.includes("review") || normalized.includes("summary")) {
      return "Review the model configuration carefully before submitting.";
    }

    if (normalized.includes("model")) {
      return "Provide the model details and upload the required model artifacts.";
    }

    if (normalized.includes("sample") || normalized.includes("image")) {
      return "Upload sample assets that help validate or convert this model.";
    }

    if (normalized.includes("source")) {
      return "Choose how you want to add the model files for this workflow.";
    }

    return "Complete the required information for this step before continuing.";
  };

  let steps_url;

  if (props?.project_model) {
    steps_url = `${window["ENV"].API_URL}/${props.path}&step=${activeStep}`;
  } else {
    steps_url = `${window["ENV"].API_URL}/${props.path}?step=${activeStep}`;
  }

  useEffect(() => {
    if (!data) return;
    activeStep = 0;
    console.log('Initial data received:', data);
    // setActiveStep(0);
    setSchema(prepareModelFormSchema(data.json_schema));
    setTempCredentials(data.temp_aws_cred);
    setFormresult(data);
    if (props.useOwnershipAccessToggles) {
      setFormData((currentFormData) =>
        applyOwnershipAccessDefaults(data.json_schema, currentFormData)
      );
    }
    // setStreamingUrl(data?.streaming?.["streaming-device"]?.[0]?.stream1?.webrtc_url);

    const customUiSchema = {
      ...buildModelUiSchema(data.ui_schema),
      "Stream Name": {
        "ui:widget": "VideoWidget"
      },
    };
    setUischema(customUiSchema);

    return () => {
      console.log('Component cleanup');
      currentFileRef.current = null;
      setCurrentFile(null);
      setUploadProgress(0);
      setUploading(false);
    };
  }, [data]);

  const handleFileSelect = useCallback((file) => {
    console.log('File selected:', file ? {
      name: file.name,
      size: file.size,
      type: file.type
    } : null);
    currentFileRef.current = file || null;
    setCurrentFile(file || null);
    setFormData((currentFormData) => {
      const nextFormData = { ...currentFormData };
      if (file) {
        nextFormData["Upload Model"] = file.name;
      } else {
        delete nextFormData["Upload Model"];
      }

      return props.useOwnershipAccessToggles
        ? applyOwnershipAccessDefaults(schema, nextFormData)
        : nextFormData;
    });
    setUploadProgress(0);
    setUploading(false);
  }, [props.useOwnershipAccessToggles, schema]);

  const handleFormChange = ({ formData: newFormData }) => {
    console.log('Form data changed:', newFormData);
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        ...newFormData,
      };

      if (currentFileRef.current) {
        nextFormData["Upload Model"] = currentFileRef.current.name;
      }

      return props.useOwnershipAccessToggles
        ? applyOwnershipAccessDefaults(schema, nextFormData)
        : nextFormData;
    });

  };



  const filehandler = (file) => {
    console.log('File handler called with:', file);
    setCurrentFile(file);
  };

  const handleS3Upload = async (file) => {
    if (!file || !tempCredentials) {
      console.error('Missing required upload parameters');
      throw new Error("Missing file or credentials");
    }

    console.log('Starting S3 upload for file:', file.name);
    setUploading(true);
    setUploadProgress(0);

    try {
      const uploadParams = {
        Bucket: S3_BUCKET,
        Key: activeStep === 0 ? `model_hub/${formData?.["Model Name"]}/model/${file.name}` : `model_hub/${formData?.["Model Name"]}/sample_images/${file.name}`,
        Body: file
      };


      let images_path;
      if (activeStep === 0) {
        setModelpath(uploadParams?.Key);
      } else {
        images_path = uploadParams?.Key;
      }


      console.log('Upload parameters:', {
        bucket: S3_BUCKET,
        region: REGION,
        filename: file.name
      });

      const uploader = new Upload({
        client: new S3Client({
          region: REGION,
          credentials: {
            accessKeyId: tempCredentials.aws_access_key_id,
            secretAccessKey: tempCredentials.aws_secret_access_key,
            sessionToken: tempCredentials.aws_session_token,
          },
        }),
        leavePartsOnError: false,
        params: uploadParams,
      });

      uploader.on("httpUploadProgress", (progress) => {
        const percentage = Math.round((progress.loaded / progress.total) * 100);
        console.log('Upload progress:', percentage + '%');
        setUploadProgress(percentage);
      });

      await uploader.done();
      console.log('Upload completed successfully');

      return {
        access_key: tempCredentials.aws_access_key_id,
        secret_key: tempCredentials.aws_secret_access_key,
        session_token: tempCredentials.aws_session_token,
        bucket_name: S3_BUCKET,
        model_folder_name: props.project_model ? model_path : uploadParams?.Key,
        folder_name: images_path
      };
    } catch (error) {
      console.error('Upload failed:', error);
      throw error;
    } finally {
      setUploading(false);
    }
  };

  const handleFormSubmit = async ({ formData: newFormData }, e) => {
    e.preventDefault();
    console.log('Form submission started:', {
      currentStep: activeStep,
      formData: newFormData,
      selectedSource: newFormData["Source"]
    });

    setLoad(true);
    setLoadingAction("next");

    try {
      let finalFormData = { ...formData, ...newFormData };
      console.log('Processing step', activeStep, 'submission');

      if (props.project_model ? (activeStep === 0 || activeStep === 1) : activeStep === 0) {
        if (finalFormData["Source"] === "BrowserUpload") {
          if (!currentFile) {
            setAlert("Please select a file first");
            setLoad(false);
            return;
          }

          try {
            const uploadResult = await handleS3Upload(currentFile);
            console.log("uploadresult",uploadResult);
            finalFormData = {
              ...finalFormData,
              Source: "BrowserUpload",
              ...uploadResult
            };
          } catch (error) {
            console.error('Browser upload failed:', error);
            setAlert("Upload failed: " + error.message);
            setLoad(false);
            return;
          }
        }

      }

      console.log('Sending form data to server:', finalFormData);

      const response = await fetch(
        steps_url,
        {
          method: "post",
          headers: {
            "Authorization": `Bearer ${getCokkie("jwtToken")}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify(finalFormData)
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.detail || "Submission failed");
      }

      if (result.summary) {
        setSchema({ configuration: result.summary });
        setFormData(result.summary);
        setSummaryforui({ configuration: result.summary.summary_for_ui })
      } else {
        setSchema(prepareModelFormSchema(result.json_schema));
        setUischema({
          ...buildModelUiSchema(result.ui_schema),
          "Stream Name": {
            "ui:widget": "VideoWidget"
          },
        });
        setFormData(
          props.useOwnershipAccessToggles
            ? applyOwnershipAccessDefaults(result.json_schema, finalFormData)
            : finalFormData
        );
      }

      // setActiveStep(result.active_step || activeStep + 1);
      activeStep = result?.active_step ?? activeStep++;

    } catch (error) {
      console.error('Form submission failed:', error);
      setAlert(error.message);
    } finally {
      setLoad(false);
      setLoadingAction(null);
    }
  };
  const handleBack = async (e) => {

    e.preventDefault();
    console.log("backstep", activeStep);
    console.log('Handling back navigation from step:', activeStep);

    setLoad(true);
    setLoadingAction("back");

    try {
      // const prevStep = activeStep - 2;
      activeStep = activeStep - 2;
      console.log('Navigating to previous step:', activeStep);

      let back_url;

      if (props?.project_model) {
        back_url = `${window["ENV"].API_URL}/${props.path}&step=${activeStep}`;
      } else {
        back_url = `${window["ENV"].API_URL}/${props.path}?step=${activeStep}`;
      }

      const response = await fetch(
        back_url,
        {
          method: "post",
          headers: {
            "Authorization": `Bearer ${getCokkie("jwtToken")}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify(formData)
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.detail || "Navigation failed");
      }

      if (result.summary) {
        const transformedSummary = {
          ...result.summary,
          Source: formData["Select Data Source"] || formData.Source
        };
        setFormData(transformedSummary);
        setSchema({ configuration: transformedSummary });
      } else {
        setSchema(prepareModelFormSchema(result.json_schema));
        setUischema({
          ...buildModelUiSchema(result.ui_schema),
          "Stream Name": {
            "ui:widget": "VideoWidget"
          },
        });
      }

      // setActiveStep(result.active_step || prevStep);
      activeStep = result?.active_step;

      if (activeStep === 0) {
        setCurrentFile(null);
        setUploadProgress(0);
        setUploading(false);
      }

    } catch (error) {
      console.error('Back navigation failed:', error);
      setAlert(error.message);
    } finally {
      setLoad(false);
      setLoadingAction(null);
    }
  };

  const handleFinalSubmit = async (e) => {
    e.preventDefault();
    console.log('Handling final form submission');

    setLoad(true);
    setLoadingAction("submit");

    try {
      const finalData = schema.configuration;
      console.log('Submitting final configuration:', finalData);

      const response = await fetch(
        steps_url,
        {
          method: "post",
          headers: {
            "Authorization": `Bearer ${getCokkie("jwtToken")}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify(finalData)
        }
      );

      const result = await response.json();

      if (isErrorSubmissionResult(response, result)) {
        throw new Error(
          extractResponseMessage(result?.detail || result?.message || result?.error)
        );
      }

      setAlert(result.detail);
      props.close?.();
      props?.onModelAdded();
      props.handleRedirect?.();
    } catch (error) {
      console.error('Final submission failed:', error);
      setAlert(error.message);
    } finally {
      setLoad(false);
      setLoadingAction(null);
    }
  };

  if (loading) {
    return (
      <div className="modelhub-add-model-overlay evaluate-model-ui">
        <div
          className="modelhub-add-model-panel modelhub-add-model-panel--slide-in d-flex flex-column"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modelhub-add-model-header">
            <div className="d-a gap-2 w-100">
              <ModelIcon
                className="wf-icon-blue text-white bg-primary fw-bold p-2"
                style={{ height: "40px", width: "40px" }}
              />
              <div className="w-100">
                <div className="d-a justify-content-between w-100">
                  <div className="main-title mb-0">Add New Model</div>
                  <CloseIcon
                    onClick={props.close}
                    className="wf-icon cursor-pointer"
                  />
                </div>
                <p className="sub-title m-0">
                  Configure and publish a model to the hub using the guided stepper.
                </p>
              </div>
            </div>
          </div>

          <div className="modelhub-add-model-body">
            <AlertComponent
              alert={props.alert}
              close={props.clearAlert}
              topright="normal"
            />
            <div className="modelhub-add-model-content">
              <Loader />
              {uploading && (
                <>
                  <div className="text-center">{uploadProgress} %</div>
                  <Progress value={uploadProgress} />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modelhub-add-model-overlay evaluate-model-ui">
      <div
        className="modelhub-add-model-panel modelhub-add-model-panel--slide-in d-flex flex-column"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modelhub-add-model-header">
          <div className="d-a gap-2 w-100">
            <ModelIcon
              className="wf-icon-blue text-white bg-primary fw-bold p-2"
              style={{ height: "40px", width: "40px" }}
            />
            <div className="w-100">
              <div className="d-a justify-content-between w-100">
                <div className="main-title mb-0">Add New Model</div>
                <CloseIcon
                  onClick={props.close}
                  className="wf-icon cursor-pointer"
                />
              </div>
              <p className="sub-title m-0">
                Step {currentStepNumber} of {totalSteps}: {currentStepLabel}
              </p>
            </div>
          </div>
        </div>

        <div className="modelhub-add-model-body">
          <AlertComponent
            alert={props.alert}
            close={props.clearAlert}
            topright="normal"
          />

          <div className="modelhub-add-model-content">
            {schema && activeStep !== data?.steppers?.length - 1 ? (
              <div className="form-container modelhub-add-model-form dataset-flow-shell">
                <div className="form-shell__intro">
                  <div className="dataset-flow-shell__eyebrow">
                    <div className="dataset-flow-shell__step-flow">
                      {visibleHeaderSteps.map((stepLabel, index) => {
                        const stepNumber = index + 1;
                        const isCurrentHeaderStep = stepNumber === currentStepNumber;

                        return (
                          <div
                            key={`${stepLabel}-${stepNumber}`}
                            className="dataset-flow-shell__step-item"
                          >
                            {isCurrentHeaderStep ? (
                              <span className="dataset-flow-shell__step-badge">
                                Step {stepNumber}
                              </span>
                            ) : (
                              <span className="dataset-flow-shell__step-marker">
                                {stepNumber}
                              </span>
                            )}
                            <span
                              className={`dataset-flow-shell__step-name ${
                                isCurrentHeaderStep
                                  ? "dataset-flow-shell__step-name--active"
                                  : "text-secondary"
                              }`}
                            >
                              {stepLabel}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <p className="mb-0 text-white">{getStepDescription(currentStepLabel)}</p>
                </div>
                <ModelFileWidgetContext.Provider
                  value={{
                    uploading,
                    uploadProgress,
                    onUpload: handleFileSelect,
                    selectedFile: currentFile,
                  }}
                >
                  <Form
                    id="add-model-form"
                    schema={schema}
                    uiSchema={uischema}
                    widgets={widgets}
                    FieldTemplate={ModelFlowFieldTemplate}
                    ObjectFieldTemplate={DatasetFlowObjectFieldTemplate}
                    ArrayFieldTemplate={DatasetFlowArrayFieldTemplate}
                    formData={formData}
                    onChange={handleFormChange}
                    onSubmit={handleFormSubmit}
                    showErrorList={false}
                  >
                    {uploading && (
                      <>
                        <div className="text-center">{uploadProgress} %</div>
                        <Progress value={uploadProgress} />
                      </>
                    )}
                    <button type="submit" className="d-none" aria-hidden="true" tabIndex={-1} />
                  </Form>
                </ModelFileWidgetContext.Provider>
              </div>
            ) : schema ? (
              <>
                <div className="form-shell__intro">
                  <div className="dataset-flow-shell__eyebrow">
                    <div className="dataset-flow-shell__step-flow">
                      {visibleHeaderSteps.map((stepLabel, index) => {
                        const stepNumber = index + 1;
                        const isCurrentHeaderStep = stepNumber === currentStepNumber;

                        return (
                          <div
                            key={`${stepLabel}-${stepNumber}`}
                            className="dataset-flow-shell__step-item"
                          >
                            {isCurrentHeaderStep ? (
                              <span className="dataset-flow-shell__step-badge">
                                Step {stepNumber}
                              </span>
                            ) : (
                              <span className="dataset-flow-shell__step-marker">
                                {stepNumber}
                              </span>
                            )}
                            <span
                              className={`dataset-flow-shell__step-name ${
                                isCurrentHeaderStep
                                  ? "dataset-flow-shell__step-name--active"
                                  : "text-secondary"
                              }`}
                            >
                              {stepLabel}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <p className="mb-0" style={{ color: "#d6edff" }}>
                    {getStepDescription(currentStepLabel)}
                  </p>
                </div>
                <div className="modelhub-add-model-summary">
                  <ModelUploadSummary expData={summary_for_ui} />
                </div>
              </>
            ) : (
              <ErrorScreen message={error || "No form Found"} />
            )}
          </div>
        </div>
        {schema && (
          <div className="dataset-footer">
            <div className="dataset-footer__actions">
              {activeStep === 0 ? (
                <div />
              ) : (
                <button
                  type="button"
                  className="btn btn-secondary mt-0 text-white py-2"
                  onClick={handleBack}
                >
                  <BackIcon className="wf-icon me-2 text-white dataset-flow-shell__back-icon" />
                  {loadingAction === "back" ? "Loading..." : "Back"}
                </button>
              )}

              {!isLastStep ? (
                <button
                  type="submit"
                  form="add-model-form"
                  className="btn btn-primary py-2 m-0 fw-bold"
                  disabled={
                    uploading ||
                    (activeStep === 0 &&
                      formData["Source"] === "BrowserUpload" &&
                      !currentFile)
                  }
                >
                  {loadingAction === "next" ? "Loading..." : "Next"}
                  {loadingAction !== "next" && <ArrowRightIcon className="wf-icon text-white" />}
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary py-2 m-0 fw-bold"
                  onClick={handleFinalSubmit}
                  disabled={loading}
                >
                  {loadingAction === "submit" ? "Submitting..." : "Submit"}
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
